export default class Confirm {

	constructor() {

		var $this = this;

		// $('.js-confirm').addClass('needs-confirmation');

		$( "body" ).on( "click", ".js-confirm", function(e) {

			var obj = $(this);

			e.preventDefault();

			swal.fire({
				title: $this.getConfirmMessage(obj),
				text: obj.attr('data-confirm-para'),
				icon: 'warning',
				showCancelButton: true,
				confirmButtonText: obj.attr('data-confirm-button') || "OK",
				cancelButtonText: obj.attr('data-cancel-button') || "Cancel",
				confirmButtonColor: '#d33',
				// cancelButtonColor: '#d33',
			}).then((result) => {

				if (result.value) {

					obj.closest('form').submit();

				} else {

				}

			});

		});

	}

	getConfirmMessage(obj) {

		var message = obj.attr('data-confirm-message');

		if (typeof message == 'undefined') {
			return "Are you sure?";
		}		

		var field = obj.attr('data-field');

		if (typeof field !== 'undefined' && field !== false) {
			var value = document.getElementById(field).value;
		} else {
			value = '';
		}

		return obj.attr('data-confirm-message').replace('[field]', value);
	}

}